import { calendarService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { createUUID } from "@miplatform/utils";
import { useCalendarStore } from "../../stores/calendarsStore/calendarsStore";

const getCalendarSetsUUID = createUUID();

export const useMyCalendarSets = () => {
  const stateManager = useComponentState();

  const calendarSetConfigs = useCalendarStore(
    (state) => state.calendarSetConfigs
  );
  const setCalendarSetConfigs = useCalendarStore(
    (state) => state.setMultipleCalendarSetConfigs
  );

  const getMyCalendarSets = () => {
    stateManager.abort(getCalendarSetsUUID);
    stateManager.run(async () => {
      const response = await calendarService.calendarSets.getMyCalendarSets({
        sort: "displayOrder asc",
      });

      if (response.status === HTTP_STATUSES.OK) {
        setCalendarSetConfigs(response.data);
      }
    }, getCalendarSetsUUID);
  };

  return {
    loading: stateManager.isBusy(),
    myCalendarSets: Object.values(calendarSetConfigs)
      .map((set) => set.config)
      .sort((a, b) => a.displayOrder - b.displayOrder),
    getMyCalendarSets,
  };
};
